import NextIcon from './component'

export default NextIcon
